import { Button } from "@components/atoms/Button"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { cn } from "@utils/tw"
import { defineBlock, EditableText } from "eddev/blocks"
import { Link } from "eddev/routing"
import Marquee from "react-fast-marquee"
import { useWindowSize } from "usehooks-ts"

export const meta: BlockMeta = {
  title: "Media Carousel",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/media-carousel", (props) => {
  const items = props.media || []
  const { width } = useWindowSize()
  const isMobile = width < 900

  return (
    <div className="w-full mx-auto flex flex-col gap-7 my-10">
      <div className="w-full overflow-hidden">
        {env.client && (
          <Marquee speed={50} autoFill className="flex items-center">
            {env.admin && (!items || items.length === 0) && (
              <div className="h-mediaCarouselItemH aspect-square flex items-center justify-center bg-grey rounded-xl -ml-[1px]">
                <p className="type-label-m">No media selected</p>
              </div>
            )}
            {items?.map((item, index) => {
              const El = item?.link?.url ? Link : "div"
              const elProps = item?.link?.url
                ? {
                    href: item.link.url,
                    target: item.link.target || "_self",
                  }
                : {}

              return (
                <El
                  key={index}
                  {...elProps}
                  className={cn(
                    "w-auto h-mediaCarouselItemH flex items-center justify-center rounded-xl overflow-hidden -ml-[1px]",
                  )}
                >
                  {item?.image && <ResponsiveImage {...item.image} className="w-auto h-full" />}
                  {item?.video && (
                    <video
                      className="w-auto h-full object-cover object-center block"
                      src={item.video.mediaItemUrl || ""}
                      autoPlay
                      playsInline
                      muted
                      loop
                    />
                  )}
                  {!item?.image && !item?.video && env.admin && (
                    <div className="h-full aspect-square flex items-center justify-center bg-grey">
                      <p className="type-label-m">No media selected</p>
                    </div>
                  )}
                </El>
              )
            })}
          </Marquee>
        )}
      </div>
    </div>
  )
})
